import { BasePage } from '@/components/ui/base-page'

export function MediaPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add MediaPage specific content here */}
    </BasePage>
  )
}